import { Reducer } from "redux";

import { ReceivedMethodMasterResponse } from "../models/Api/Patient";
import { PriorAuthReceivedMethodDispatchTypes } from "../models/DispatchTypes/Patient";
import { PriorAuthReceivedMethodActionDispatchTypes } from "../constants/Patient";
import { setLocalStorageData } from "../utils";

const initialState: ReceivedMethodMasterResponse = {
  loading: false,
  response: [],
};

const PriorAuthReceivedMethodReducer: Reducer<
  ReceivedMethodMasterResponse,
  PriorAuthReceivedMethodDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS: {
      setLocalStorageData(
        PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default PriorAuthReceivedMethodReducer;
